import { useState, useEffect } from "react"; 
import { jwtFetch } from "./utils/apiClient";
import { useParams, useNavigate } from "react-router-dom";
import Select from "react-select";
import { config, priceFormat, numberFormat } from "./Components/Config";
import Menu from "./Components/Menu";
import Header from "./Components/Header";

const ProductEdit = () => {
  const { id_product } = useParams();
  const [ categories, setCategories ] = useState(null);
  const [ subcategories, setSubcategories ] = useState(null);
  const [ productCategory, setProductCategory ] = useState(null);
  const [ productSubcategory, setProductSubcategory ] = useState(null);
  const [ productName, setProductName ] = useState('');
  const [ productDescription, setProductDescription ] = useState('');
  const [ productType, setProductType ] = useState('Subscription');
  const [ productUnit, setProductUnit ] = useState('Seat');
  const [ productCountry, setProductCountry ] = useState('Indonesia');
  const [ productCurrency, setProductCurrency ] = useState('IDR');
  const [ productCost, setProductCost ] = useState('0');
  const [ productPrice, setProductPrice ] = useState('0');
  const [ productMarginPrice, setProductMarginPrice ] = useState('0');
  const [ productMarginRate, setProductMarginRate ] = useState('0');
  const [ productStatus, setProductStatus ] = useState('Active');
  const [ isLoadingSubmit, setIsLoadingSubmit ] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    getCategories();
  }, []);
  
  useEffect(() => {
    if (categories) {
      getProduct();
    }
  }, [categories]);

  useEffect(() => {
    setSubcategories(null);
    // setProductSubcategory(null);
    if (productCategory) {
      getSubcategories();
    }
  }, [productCategory]);
  
  useEffect(() => {
    setProductMarginPrice(parseFloat((productPrice - productCost).toFixed(3)));
    setProductMarginRate(productPrice > 0 ? parseFloat(((productPrice - productCost) / productPrice * 100).toFixed(3)) : 0);
  }, [productPrice, productCost]);

  const getProduct = async () => {
    try {
      const requestProduct = {
        "id_product": id_product
      };
      const fetchProduct = await jwtFetch(config.ENDPOINT + 'get/product', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestProduct)
      });
      const responseProduct = await fetchProduct.json();
      if (responseProduct.status === 200) {
        setProductName(responseProduct.data[0].product_name);
        setProductDescription(responseProduct.data[0].product_description);
        setProductType(responseProduct.data[0].product_type);
        setProductUnit(responseProduct.data[0].product_unit);
        setProductCountry(responseProduct.data[0].product_country);
        setProductCurrency(responseProduct.data[0].product_currency);
        setProductCost(responseProduct.data[0].product_cost);
        setProductPrice(responseProduct.data[0].product_price);
        setProductStatus(responseProduct.data[0].product_status);
        setProductCategory({
          value: responseProduct.data[0].product_category_id,
          label: responseProduct.data[0].category_name,
        });
        setProductSubcategory({
          value: responseProduct.data[0].product_subcategory_id,
          label: responseProduct.data[0].subcategory_name,
        });
      } else {
        alert(responseProduct.message);
      }
    } catch (error) {
      console.error('Error in getProduct:', error);
      alert('An error occurred: ' + (error.message || error));
    }
  }

  const getCategories = async () => {
    try {
      const requestCategories = {
        "product_category_status": 'Active'
      };
      const fetchCategories = await jwtFetch(config.ENDPOINT + 'get/product_category', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestCategories)
      });
      const responseCategories = await fetchCategories.json();
      if (responseCategories.status === 200) {
        for (let i in responseCategories.data) {
          responseCategories.data[i].value = responseCategories.data[i].id_product_category;
          responseCategories.data[i].label = responseCategories.data[i].product_category_name;
        }
        setCategories([...responseCategories.data].sort((a, b) => (a.product_category_name || '').localeCompare(b.product_category_name || '')));
      } else {
        alert(responseCategories.message);
      }
    } catch (error) {
      console.error('Error in getCategories:', error);
      alert('An error occurred: ' + (error.message || error));
    }
  }

  const getSubcategories = async () => {
    try {
      const requestSubcategories = {
        "product_category_id": productCategory.value,
        "product_subcategory_status": 'Active'
      };
      const fetchSubcategories = await jwtFetch(config.ENDPOINT + 'get/product_subcategory', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestSubcategories)
      });
      const responseSubcategories = await fetchSubcategories.json();
      if (responseSubcategories.status === 200) {
        for (let i in responseSubcategories.data) {
          responseSubcategories.data[i].value = responseSubcategories.data[i].id_product_subcategory;
          responseSubcategories.data[i].label = responseSubcategories.data[i].product_subcategory_name;
        }
        setSubcategories([...responseSubcategories.data].sort((a, b) => (a.product_subcategory_name || '').localeCompare(b.product_subcategory_name || '')));
      } else {
        alert(responseSubcategories.message);
      }
    } catch (error) {
      console.error('Error in getSubcategories:', error);
      alert('An error occurred: ' + (error.message || error));
    }
  }
  
  const changeCategoryData = (value) => {
    const category = categories.find(category => category.id_product_category == value);
    setProductCategory(category);
  }
  
  const changeSubcategoryData = (value) => {
    const subcategory = subcategories.find(subcategory => subcategory.id_product_subcategory == value);
    setProductSubcategory(subcategory);
  }

  const submitProductEdit = async (e) => {
    try {
      e.preventDefault();
      setIsLoadingSubmit(true);
      const requestProductEdit = {
        "id_product": id_product,
        "product_category_id": productCategory.value,
        "product_subcategory_id": productSubcategory.value,
        "product_name": productName,
        "product_description": productDescription,
        "product_type": productType,
        "product_unit": productUnit,
        "product_country": productCountry,
        "product_currency": productCurrency,
        "product_cost": numberFormat(productCost),
        "product_price": numberFormat(productPrice),
        "product_status": productStatus
      }
      const fetchProductEdit = await jwtFetch(config.ENDPOINT + 'update/product', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestProductEdit)
      });
      const responseProductEdit = await fetchProductEdit.json();
      if (responseProductEdit.status === 200) {
        window.location.href = '/product/detail/' + id_product;
      } else {
        alert(responseProductEdit.message);
        setIsLoadingSubmit(false);
      }
    } catch (error) {
      console.error('Error in submitProductEdit:', error);
      alert('An error occurred: ' + (error.message || error));
      setIsLoadingSubmit(false);
    }
  }

  return (
    <div id="product-edit">
      <div className="container-fluid p-0">
        <div className="row g-0 mh-100vh">
          <div className="col-md-2 border-end">
            <div className="d-md-flex d-none align-items-center justify-content-center p-1 h-48">
              <a className="h-100" href="/dashboard"><img className="h-100" src="/cuancuan.png" alt="PointStar"/></a>
            </div>
            <hr className="m-0"/>
            <Menu active="product"/>
          </div>
          <div className="col-md-10">
            <Header/>
            <hr className="m-0"/>
            <div className="main">
              <div className="p-4">

                <section className="mb-4">
                  <div className="fs-24 mb-3"><button className="btn btn-link" onClick={() => navigate(-1)}><i className="bi bi-arrow-left"/></button> Product Edit</div>
                  <form className="row" onSubmit={(e) => submitProductEdit(e)}>
                    <div className="col-md-6">
                      <div className="row form-group align-items-center mb-2">
                        <div className="col-md-4">
                          <label>Category <span className="text-danger">*</span></label>
                        </div>
                        <div className="col-md-8">
                          <Select value={productCategory} options={categories} placeholder="" onChange={(e) => changeCategoryData(e.value)} required/>
                        </div>
                      </div>
                      <div className="row form-group align-items-center mb-2">
                        <div className="col-md-4">
                          <label>Subcategory <span className="text-danger">*</span></label>
                        </div>
                        <div className="col-md-8">
                          <Select value={productSubcategory} options={subcategories} placeholder="" onChange={(e) => changeSubcategoryData(e.value)} isDisabled={!productCategory} required/>
                        </div>
                      </div>
                      <div className="row form-group align-items-center mb-2">
                        <div className="col-md-4">
                          <label>Name <span className="text-danger">*</span></label>
                        </div>
                        <div className="col-md-8">
                          <input className="form-control" type="text" value={productName} onChange={(e) => setProductName(e.target.value)} required/>
                        </div>
                      </div>
                      <div className="row form-group align-items-baseline mb-2">
                        <div className="col-md-4">
                          <label>Description</label>
                        </div>
                        <div className="col-md-8">
                          <textarea className="form-control" value={productDescription} onChange={(e) => setProductDescription(e.target.value)}/>
                        </div>
                      </div>
                      <div className="row form-group align-items-center mb-2">
                        <div className="col-md-4">
                          <label>Type <span className="text-danger">*</span></label>
                        </div>
                        <div className="col-md-8">
                          <select className="form-select" value={productType} onChange={(e) => setProductType(e.target.value)} required>
                            <option value="Licence">Licence</option>
                            <option value="Hardware">Hardware</option>
                            <option value="Service">Service</option>
                            <option value="Package">Package</option>
                          </select>
                        </div>
                      </div>
                      <div className="row form-group align-items-center mb-2">
                        <div className="col-md-4">
                          <label>Country <span className="text-danger">*</span></label>
                        </div>
                        <div className="col-md-8">
                          <select className="form-select" value={productCountry} onChange={(e) => setProductCountry(e.target.value)} required>
                            <option value="Indonesia">Indonesia</option>
                            <option value="Malaysia">Malaysia</option>
                            <option value="Singapore">Singapore</option>
                            <option value="Pakistan">Pakistan</option>
                            <option value="Thailand">Thailand</option>
                            <option value="Philippines">Philippines</option>
                          </select>
                        </div>
                      </div>
                      <div className="row form-group align-items-center mb-2">
                        <div className="col-md-4">
                          <label>Currency <span className="text-danger">*</span></label>
                        </div>
                        <div className="col-md-8">
                          <select className="form-select" value={productCurrency} onChange={(e) => setProductCurrency(e.target.value)} required>
                            <option value="USD">USD</option>
                            <option value="IDR">IDR</option>
                            <option value="MYR">MYR</option>
                            <option value="SGD">SGD</option>
                          </select>
                        </div>
                      </div>
                      <div className="row form-group align-items-center mb-2">
                        <div className="col-md-4">
                          <label>Cost Price <span className="text-danger">*</span></label>
                        </div>
                        <div className="col-md-8">
                          <div className="input-group">
                            <input className="form-control text-end" type="text" value={priceFormat(productCost, '', true)} onChange={(e) => setProductCost(numberFormat(e.target.value))} required/>
                            <span className="input-group-text">{productCurrency}</span>
                          </div>
                        </div>
                      </div>
                      <div className="row form-group align-items-center mb-2">
                        <div className="col-md-4">
                          <label>Price <span className="text-danger">*</span></label>
                        </div>
                        <div className="col-md-8">
                          <div className="input-group">
                            <input className="form-control text-end" type="text" value={priceFormat(productPrice, '', true)} onChange={(e) => setProductPrice(numberFormat(e.target.value))} required/>
                            <span className="input-group-text">{productCurrency}</span>
                          </div>
                        </div>
                      </div>
                      <div className="row form-group align-items-center mb-2">
                        <div className="col-md-4">
                          <label>Margin</label>
                        </div>
                        <div className="col-md-3">
                          <div className="input-group">
                            <input className="form-control text-end" type="text" value={priceFormat(productMarginRate)} required disabled/>
                            <span className="input-group-text">%</span>
                          </div>
                        </div>
                        <div className="col-md-5">
                          <div className="input-group">
                            <input className="form-control text-end" type="text" value={priceFormat(productMarginPrice)} required disabled/>
                            <span className="input-group-text">{productCurrency}</span>
                          </div>
                        </div>
                      </div>
                      <div className="row form-group align-items-center mb-4">
                        <div className="col-md-4">
                          <label>Status <span className="text-danger">*</span></label>
                        </div>
                        <div className="col-md-8">
                          <div className="form-check form-switch">
                            <input id="user-active" className="form-check-input" type="checkbox" value="Active" onChange={() => setProductStatus(productStatus === 'Active' ? 'Inactive' : 'Active')} checked={productStatus === 'Active' ? true : false}/>
                            <label htmlFor="user-active" className="form-check-label">{productStatus}</label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="d-flex justify-content-end mb-4">
                        <button className="btn btn-sm btn-link text-danger" type="button" onClick={() => window.location.href = '/product/detail/' + id_product}>Cancel</button>
                        <button className="btn btn-sm btn-primary ms-2" type="submit" disabled={isLoadingSubmit}>{isLoadingSubmit ? 'Loading...' : 'Update'}</button>
                      </div>
                    </div>
                  </form>
                </section>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductEdit;


